import React from 'react';
import Routers from './pages/Routes';

function App() {
  return (
      <Routers />
  );
}

export default App;
